import i18n from '/common/plugins/vue-i18n.js' 
let lang = window.localStorage.getItem('language');
if(!lang)	
{
    lang = "zh_TW"				
}
i18n.locale = lang


const GPTModelParameterList =  {
    verbosity:[
        {name:"Low",id:"low"},
        {name:"Medium",id:"medium"},
        {name:"High",id:"high"},
    ],
    reasoning_effort:[
        {name:"Minimal",id:"minimal"},
        {name:"Low",id:"low"},
        {name:"Medium",id:"medium"},
        {name:"High",id:"high"},
    ]
}

export default GPTModelParameterList;